var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ 'n-link': _vm.hasRO },attrs:{"title":_vm.label},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }